/**
 * WebEngage custom events: Banner Clicked, Footer Clicked,
 * Review Button Clicked, Product Description, Fragrance Notes,
 * Additional Information, How To Use, FAQS, Product Image Viewed.
 * Waits for the Shopify WebEngage app SDK, then tracks via webengage.track.
 */
(function () {
  function webengageOnReady(callback, attempt) {
    var tries = attempt || 0;
    if (typeof webengage !== 'undefined' && typeof webengage.onReady === 'function') {
      webengage.onReady(callback);
      return;
    }
    if (tries >= 50) return;
    setTimeout(function () {
      webengageOnReady(callback, tries + 1);
    }, 100);
  }

  function toStringValue(value) {
    if (value == null) return '';
    return String(value).replace(/\s+/g, ' ').trim();
  }

  function toNumberValue(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function toAbsoluteUrl(url) {
    const value = toStringValue(url);
    if (!value) return '';
    if (value.indexOf('//') === 0) return 'https:' + value;
    if (value.charAt(0) === '/' && value.charAt(1) !== '/') {
      return window.location.origin + value;
    }
    return value;
  }

  function trackEvent(eventName, eventData) {
    webengageOnReady(function () {
      if (typeof webengage === 'undefined' || typeof webengage.track !== 'function') return;
      webengage.track(eventName, eventData);
    });
  }

  function getLinkLabel(link) {
    const ariaLabel = toStringValue(link.getAttribute('aria-label'));
    if (ariaLabel) return ariaLabel;

    const text = toStringValue(link.textContent);
    if (text) return text;

    return toStringValue(link.getAttribute('href'));
  }

  function getBannerPosition(banner) {
    const fromAttr = toStringValue(banner.getAttribute('data-we-banner-position'));
    if (fromAttr) return fromAttr;

    const category = banner.getAttribute('data-we-banner-category') || '';
    const selector = category
      ? '[data-we-event="banner"][data-we-banner-category="' + category + '"]'
      : '[data-we-event="banner"]';
    const banners = Array.prototype.slice.call(document.querySelectorAll(selector));
    const index = banners.indexOf(banner);
    return index >= 0 ? String(index + 1) : '';
  }

  function getProductPayload() {
    const script = document.querySelector('[data-we-product-json]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariant(productData) {
    if (!productData) return {};

    const productId = productData.productId != null ? String(productData.productId) : '';
    const formInput = document.querySelector(
      (productId ? 'product-form-component[data-product-id="' + productId + '"] ' : '') + 'input[name="id"]'
    );
    const variantId = toStringValue((formInput && formInput.value) || productData.defaultVariantId);
    const variants = productData.variants || {};

    return variants[variantId] || variants[String(productData.defaultVariantId)] || {};
  }

  function buildProductEventData(includeRating, omitImage) {
    const productData = getProductPayload();
    if (!productData) return null;

    const variant = getSelectedVariant(productData);
    const eventData = {
      'Product ID': toStringValue(productData.productId),
      'Product Type': toStringValue(productData.productType),
      Price: toNumberValue(variant.price),
      Title: toStringValue(productData.title),
      'Variant ID': toStringValue(variant.variantId || productData.defaultVariantId),
      'Variant Title': toStringValue(variant.variantTitle),
    };

    if (!omitImage) {
      eventData.Image = toAbsoluteUrl(variant.image);
    }

    if (includeRating) {
      eventData.Rating = toNumberValue(productData.rating);
    }

    return eventData;
  }

  function trackBannerClicked(banner) {
    trackEvent('Banner Clicked', {
      'Banner Name': toStringValue(banner.getAttribute('data-we-banner-name')),
      'Banner Category': toStringValue(banner.getAttribute('data-we-banner-category')),
      'Banner Position': getBannerPosition(banner),
      'Banner ID': toStringValue(banner.getAttribute('data-we-banner-id')),
      'Page URL': window.location.href,
    });
  }

  function trackFooterClicked(link) {
    const footerName = getLinkLabel(link);
    if (!footerName) return;

    trackEvent('Footer Clicked', {
      'Footer Name': footerName,
    });
  }

  function trackReviewButtonClicked() {
    const eventData = buildProductEventData(true);
    if (!eventData) return;
    trackEvent('Review Button Clicked', eventData);
  }

  function trackNamedProductEvent(eventName) {
    const eventData = buildProductEventData(false);
    if (!eventName || !eventData) return;
    trackEvent(eventName, eventData);
  }

  function getImageFromElement(el) {
    if (!el) return '';
    const fromAttr = el.getAttribute('data-we-image-clicked');
    if (fromAttr) return fromAttr;

    const img = el.querySelector('img') || (el.tagName === 'IMG' ? el : null);
    if (img) return img.currentSrc || img.src || '';

    return '';
  }

  function resolveProductImageClick(event) {
    const gallery = event.target.closest('media-gallery[data-we-product-gallery]');
    if (!gallery) return null;

    if (event.target.closest('zoom-dialog, .dialog-zoomed-gallery__dialog, slideshow-arrows')) {
      return null;
    }

    if (event.target.closest('.slideshow-control') && !event.target.closest('.slideshow-controls__thumbnail')) {
      return null;
    }

    const tracked = event.target.closest('[data-we-event="product-image"]');
    if (tracked) {
      return {
        position: toStringValue(tracked.getAttribute('data-we-image-position')),
        image: getImageFromElement(tracked),
      };
    }

    const thumbnail = event.target.closest('.slideshow-controls__thumbnail');
    if (thumbnail && gallery) {
      const thumbs = gallery.querySelectorAll('.slideshow-controls__thumbnails .slideshow-controls__thumbnail');
      const index = Array.prototype.indexOf.call(thumbs, thumbnail);
      return {
        position: index >= 0 ? String(index + 1) : '',
        image: getImageFromElement(thumbnail),
      };
    }

    return null;
  }

  function trackProductImageViewed(position, imageUrl) {
    const eventData = buildProductEventData(false, true);
    if (!eventData) return;

    eventData['Image Position'] = toStringValue(position);
    eventData['Image clicked'] = toAbsoluteUrl(imageUrl);
    trackEvent('Product Image Viewed', eventData);
  }

  function isOpeningAccordion(event, root) {
    if (!event.target.closest('summary')) return false;
    const details = root.closest('details') || root;
    if (details instanceof HTMLDetailsElement && details.open) return false;
    return true;
  }

  function onDocumentClick(event) {
    const reviewButton = event.target.closest('[data-we-event="review-button"]');
    if (reviewButton) {
      trackReviewButtonClicked();
    }

    const accordion = event.target.closest('[data-we-event="product-accordion"]');
    if (accordion && isOpeningAccordion(event, accordion)) {
      trackNamedProductEvent(accordion.getAttribute('data-we-event-name'));
    }

    const faqs = event.target.closest('[data-we-event="faqs"]');
    if (faqs && isOpeningAccordion(event, faqs)) {
      trackNamedProductEvent('FAQS');
    }

    const productImageClick = resolveProductImageClick(event);
    if (productImageClick) {
      trackProductImageViewed(productImageClick.position, productImageClick.image);
    }

    const link = event.target.closest('a');
    if (!link || link.getAttribute('aria-disabled') === 'true') return;

    const href = link.getAttribute('href');
    if (!href || href === '#') return;

    const banner =
      link.getAttribute('data-we-event') === 'banner' ? link : link.closest('[data-we-event="banner"]');

    if (banner) {
      trackBannerClicked(banner);
      return;
    }

    if (link.closest('footer')) {
      trackFooterClicked(link);
    }
  }

  document.addEventListener('click', onDocumentClick, true);
})();
